export const GET_SHAREPOINT = 'GET_SHAREPOINT';
export const GET_EMBED_INFO = 'GET_EMBED_INFO';
